<template>
  <template v-if="isLoading">
    <div class="loading">
      <div class="loading__loader">
        <inline-svg src="/images/icones/icon_loader.svg" />
      </div>
    </div>
  </template>
  <div ref="pdfContent" :class="isPDF ? 'pdf-mode' : ''">
    <header class="header header--underLoading pdfShow --flex">
      <inline-svg src="/images/logo.svg" :class="'header__logo'" />
    </header>
    <div class="container marginHeader marginBottom" :class="showQuestionnary || isPDF ? '' : 'd-none'">
      <div class="row">
        <div class="col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2 col-xl-6 offset-xl-3">
          <h1 class="h--headingL">
            Simulez vos remboursements<br />
            santé en 2 min
          </h1>
          <p class="chapo">
            Les résultats de remboursements sont donnés à titre indicatif dans le respect du parcours de soins coordonnés. <br />
            Cela signifie que vous devez consulter votre médecin traitant avant de consulter certains spécialistes.
          </p>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2 col-xl-6 offset-xl-3">
          <template v-if="errorMessage">
            <div class="message message--error">
              <h5 class="message__title">Une erreur est survenue lors du chargement du formulaire.</h5>
              <p class="message__text">{{ errorMessage }}</p>
            </div>
          </template>
          <template v-else>
            <section class="nature">
              <EtapeNature />
            </section>

            <transition name="slide-up" :class="isPDF ? 'no-transition' : ''">
              <section class="prestation form__separator" v-if="displayPrestation" ref="refPrestation">
                <EtapePrestation />
              </section>
            </transition>

            <transition name="slide-up" :class="isPDF ? 'no-transition' : ''">
              <section class="tarification form__separator" v-if="displayTarification" ref="refTarification">
                <EtapeTarification />
              </section>
            </transition>

            <transition name="slide-up" :class="isPDF ? 'no-transition' : ''">
              <section class="montantDispense form__separator" v-if="displayMontantDepense" ref="refMontantDepense">
                <EtapeMontantDepense @update:valid="isVuelidateValid = $event" :selectedTypeRemboursementValue="selectedTypeRemboursementValue" />
              </section>
            </transition>
          </template>
        </div>
      </div>
      <transition name="slide-up" :class="isPDF ? 'no-transition' : ''">
        <div class="row pdfHidden" v-if="displaySimulateButton">
          <div class="col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2 col-xl-6 offset-xl-3 d-flex justify-content-center">
            <button class="actionBtn" :disabled="!isVuelidateValid" @click="runSimulation(true)">
              Simuler mon remboursement
              <inline-svg src="/images/icones/icon_arrow.svg" />
            </button>
          </div>
        </div>
      </transition>
    </div>
    <!-- SIMULATEUR -->
    <template v-if="displaySimulateur && resultatsSimulation && resultatsSimulation.resultats">
      <Simulation
        :resultatsSimulation="resultatsSimulation"
        :isPDF="isPDF"
        @run-simulation="runSimulation"
        @reset-simulation="resetSimulation"
        @download-simulation="downloadSimulation"
      />
    </template>
  </div>
</template>

<script>
import { objectHelper } from "@/helpers";
import { buildLabel, computeMontantTotal, mapEtatOptam, mapTypePrestation, mapTypeSoin, mapTypeTarification, pushSimulationEvent } from "@/helpers/matomo";
import { normalizeRouteContext } from "@/helpers/entrySource";
import simulateurService from "@/services/simulateurService";
import useVuelidate from "@vuelidate/core";
import { helpers } from "@vuelidate/validators";
import EtapeNature from "@/views/Etapes/01-Nature.vue";
import EtapePrestation from "@/views/Etapes/02-Prestation.vue";
import EtapeTarification from "@/views/Etapes/03-Tarification.vue";
import EtapeMontantDepense from "@/views/Etapes/04-MontantDepense.vue";
import Simulation from "@/views/Simulation.vue";
import html2pdf from "html2pdf.js";

export default {
  name: "Home",
  components: { EtapeNature, EtapePrestation, EtapeTarification, EtapeMontantDepense, Simulation },
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    const routeContext = normalizeRouteContext(this.$route.params);

    return {
      objectHelper: objectHelper,

      isVuelidateValid: false,
      isLoading: false,
      displaySimulateur: false,
      resultatsSimulation: null,
      isPDF: false,
      showQuestionnary: true,

      //old

      // Données de l'URL
      clientCode: this.$route.params.clientCode,
      sourceEntree: routeContext.sourceEntree,
      typeRegime: routeContext.typeRegime,
      isRegimeFromUrl: routeContext.isRegimeFromUrl,

      // Gestion des erreurs
      errorMessage: null,
    };
  },
  async mounted() {
    console.debug("Component Home is mounted!");

    this.typeRegimeStore = this.typeRegime;

    pushSimulationEvent({
      event: "view_simulateur",
      action: "view",
      label: "simulateur_loaded",
      payload: {
        page_view: "page_view",
      },
    });
  },
  computed: {
    //STORE
    typeDepenseStore() {
      return this.$store.getters["dataSimulateurStore/typeDepense"];
    },
    typesDepenseAllStore() {
      return this.$store.getters["dataSimulateurStore/typesDepenseAll"];
    },
    prestationStore() {
      return this.$store.getters["dataSimulateurStore/prestation"];
    },
    prestationsAllStore() {
      return this.$store.getters["dataSimulateurStore/prestationsAll"];
    },
    tarificationStore() {
      return this.$store.getters["dataSimulateurStore/tarification"];
    },
    montantDepenseStore() {
      return this.$store.getters["dataSimulateurStore/montantDepense"];
    },
    sousPrestationStore() {
      return this.$store.getters["dataSimulateurStore/sousPrestations"];
    },
    typeRegimeStore: {
      get() {
        return this.$store.getters["dataSimulateurStore/typeRegime"];
      },
      set(value) {
        this.$store.dispatch("dataSimulateurStore/updateTypeRegime", value);
      },
    },
    optamStore: {
      get() {
        return this.$store.getters["dataSimulateurStore/isOptam"];
      },
      set(value) {
        this.$store.dispatch("dataSimulateurStore/updateOptam", value);
      },
    },
    optamVisibleStore: {
      get() {
        return this.$store.getters["dataSimulateurStore/isOptamVisible"];
      },
      set(value) {
        this.$store.dispatch("dataSimulateurStore/updateOptamVisible", value);
      },
    },
    //DISPLAY CONDITIONS
    isMontantRenseigne() {
      return this.montantDepenseStore !== 0 || (this.sousPrestationStore.length > 0 && this.sousPrestationStore.every((item) => item.montant !== 0));
    },

    displayPrestation() {
      return this.typeDepenseStore !== null;
    },

    displayTarification() {
      return this.prestationStore?.key === "TarifNonDefiniTotal" || this.prestationStore?.key === "TarifNonDefiniSemi";
    },

    displayMontantDepense() {
      return (
        this.prestationStore != null &&
        ((this.prestationStore?.key !== "TarifNonDefiniTotal" && this.prestationStore?.key !== "TarifNonDefiniSemi") || this.tarificationStore != null)
      );
    },

    displaySimulateButton() {
      return this.displayPrestation && this.displayMontantDepense && this.isMontantRenseigne;
    },

    valuePrestation() {
      if (
        this.prestationStore?.key === "TarifNonDefiniTotal" ||
        this.prestationStore?.key === "TarifNonDefiniSemi" ||
        this.prestationStore?.key === "TarifDefini"
      ) {
        switch (this.tarificationStore) {
          case "CentPourCent":
            return this.prestationsAllStore.find((item) => item.key === "CouronneCeramoMetalliqueCentPourCentSante").value;
          case "TarifMaitrise":
            return this.prestationsAllStore.find((item) => item.key === "CouronneCeramoMetalliqueTarifMaitrise").value;
          case "TarifDefini":
            return this.prestationsAllStore.find((item) => item.key === "CouronneCeramoMetalliqueTarifLibre").value;
          default:
            return this.prestationsAllStore.find((item) => item.key === "CouronneCeramoMetalliqueTarifLibre").value;
        }
      } else {
        return this.prestationStore?.value;
      }
    },

    isOptamVisible() {
      if (this.typeDepenseStore === null || !this.typesDepenseAllStore) {
        return false;
      }

      const typeDepense = this.typesDepenseAllStore[this.typeDepenseStore];
      if (!typeDepense || !typeDepense.name) {
        return false;
      }

      const typePrestation = this.prestationsAllStore[this.prestationStore.value];
      if (!typePrestation || !typePrestation.name) {
        return false;
      }

      const nameDepense = typeDepense.name.toLowerCase();
      const namePrestation = typePrestation.name.toLowerCase();
      this.optamVisibleStore =
        nameDepense.includes("généralistes et spécialistes") || (nameDepense.includes("optique") && namePrestation.includes("ophtalmologique"));
      return this.optamVisibleStore;
    },

    selectedTypeRemboursementValue() {
      if (!this.isOptamVisible) {
        return null;
      }

      return this.optamStore ? 0 : 1;
    },

    isPrestationComposite() {
      // Déterminé par la présence de sous-prestations chargées depuis l'API
      return this.sousPrestationStore.length > 0;
    },
  },
  methods: {
    getTrackingContext(includeOptam = false) {
      const typeSoin = mapTypeSoin(this.typeDepenseStore);
      const typePrestation = mapTypePrestation(this.prestationStore);
      const typeTarification = mapTypeTarification(this.tarificationStore);
      const montantTotal = computeMontantTotal(this.montantDepenseStore, this.sousPrestationStore);
      const etatOptam = mapEtatOptam(this.optamStore);

      return {
        typeSoin,
        typePrestation,
        typeTarification,
        montantTotal,
        etatOptam,
        label: buildLabel({
          typeSoin,
          typePrestation,
          typeTarification,
          etatOptam,
          includeOptam,
        }),
      };
    },

    scrollTotop() {
      const el = document.querySelector("#scrollToTop");
      const scrollEl = document.scrollingElement;

      if (el && scrollEl) {
        const top = el.getBoundingClientRect().top + scrollEl.scrollTop;

        scrollEl.scrollTo({
          top,
          behavior: "smooth",
        });
      }
    },
    // APPEL API SIMULATION
    async runSimulation(showLoadingScreen = false) {
      if (showLoadingScreen) {
        this.isLoading = true;
      }
      this.showQuestionnary = false;

      if (showLoadingScreen) {
        const trackingContext = this.getTrackingContext();

        pushSimulationEvent({
          event: "cta_simulation",
          action: "lancement_simulation",
          label: trackingContext.label,
          payload: {
            montant_total: trackingContext.montantTotal,
          },
          value: trackingContext.montantTotal,
        });
      }

      const payload = {
        TypeDepense: this.typeDepenseStore,
        TypePrestation: this.valuePrestation,
        TypeRemboursement: this.selectedTypeRemboursementValue,
        TypeRegime: this.typeRegimeStore,
      };

      if (this.isPrestationComposite) {
        // Envoyer les sous-prestations
        payload.SousPrestations = this.sousPrestationStore
          .filter((sp) => sp.montant > 0)
          .map((sp) => ({
            Code: sp.code,
            Montant: sp.montant,
          }));
      } else {
        // Envoyer le montant simple
        payload.MontantDepense = this.montantDepenseStore;
      }
      this.resultatsSimulation = await simulateurService.simulerRemboursement(this.clientCode, this.typeRegimeStore, payload);
      if (showLoadingScreen) {
        setTimeout(() => {
          this.isLoading = false;
        }, 1000);
      }
      this.scrollTotop();
      this.displaySimulateur = true;
    },

    // RESET DATA SIMULATION
    resetSimulation() {
      pushSimulationEvent({
        event: "cta_nouvelle_simulation",
        action: "nouvelle_simulation",
        label: "nouvelle_simulation",
      });

      this.scrollTotop();
      this.isLoading = true;
      this.displaySimulateur = false;
      this.$store.commit("dataSimulateurStore/RESET_STATE");
      this.showQuestionnary = true;
      this.isLoading = false;
    },

    // CREATION ET TELECHARGEMENT PDF
    async downloadSimulation() {
      const trackingContext = this.getTrackingContext(true);

      pushSimulationEvent({
        event: "telechargement_pdf",
        action: "telechargement_pdf",
        label: trackingContext.label,
      });

      this.scrollTotop();
      this.isLoading = true;
      this.isPDF = true;

      await this.$nextTick(); //attend le chargement du DOM
      await document.fonts.ready; //attend que les fonts chargent
      await new Promise((resolve) => setTimeout(resolve, 300));

      const element = this.$refs.pdfContent;
      const options = {
        margin: 0,
        filename: "SyntheseSimulation.pdf",
        image: { type: "png", quality: 1 },
        html2canvas: { scale: 3, useCORS: true },
        jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
      };

      await html2pdf().set(options).from(element).save();
      this.isPDF = false;
      this.isLoading = false;
    },

    //Fonction pour scroll à l'apparition des partial afin de définir une durée (contrairement à scrollIntoView)
    smoothScrollTo(element, duration = 1000) {
      const start = window.pageYOffset;
      const target = element.getBoundingClientRect().top + start;
      const startTime = performance.now();

      const animateScroll = (currentTime) => {
        const timeElapsed = currentTime - startTime;
        const progress = Math.min(timeElapsed / duration, 1);

        // easing (facultatif mais plus joli)
        const ease = progress * (2 - progress);

        window.scrollTo(0, start + (target - start) * ease);

        if (timeElapsed < duration) {
          requestAnimationFrame(animateScroll);
        }
      };

      requestAnimationFrame(animateScroll);
    },
  },
  watch: {
    async displayPrestation(newValue) {
      if (newValue) {
        await this.$nextTick();

        const el = this.$refs.refPrestation;
        const scrollEl = document.scrollingElement;

        const top = el.getBoundingClientRect().top + scrollEl.scrollTop;

        scrollEl.scrollTo({
          top,
          behavior: "smooth",
        });
      }
    },
    async displayTarification(newValue) {
      if (newValue) {
        await this.$nextTick();

        const el = this.$refs.refTarification;
        const scrollEl = document.scrollingElement;

        const top = el.getBoundingClientRect().top + scrollEl.scrollTop;

        scrollEl.scrollTo({
          top,
          behavior: "smooth",
        });
      }
    },
    async displayMontantDepense(newValue) {
      if (newValue) {
        await this.$nextTick();

        const el = this.$refs.refMontantDepense;
        const scrollEl = document.scrollingElement;

        const top = el.getBoundingClientRect().top + scrollEl.scrollTop;

        scrollEl.scrollTo({
          top,
          behavior: "smooth",
        });
      }
    },
  },
};
</script>

<style scoped>
.error-alert {
  max-width: 1200px;
  margin: 30px auto 20px;
  padding: 20px;
  background-color: #f8d7da;
  border: 1px solid #f5c6cb;
  border-radius: 8px;
  color: #721c24;
}

.error-alert h5 {
  margin-bottom: 10px;
  font-weight: 400;
  color: #721c24;
}

.error-alert p {
  margin: 0;
  color: #721c24;
}
</style>
